import script from "./b-live.vue?vue&type=script&lang=ts&setup=true"
export * from "./b-live.vue?vue&type=script&lang=ts&setup=true"

import "./b-live.vue?vue&type=style&index=0&id=3dc936ee&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\yang'ya'fei\\Documents\\tianshu-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3dc936ee"]])

export default __exports__